import ErrorPage from 'next/error'
import { useRouter } from 'next/router'
import { useMemo } from 'react'
import { getJobOfferData } from 'utils/api'
import { getStrapiURL } from 'utils/endpoints'

import Seo from '@/components/elements/seo'

import JobOfferDetails from './jobOfferDetails'

const JobOfferPage = ({ attributes }) => {
  const seo = useMemo(() => {
    return attributes
      ? {
          metaTitle: attributes.name,
          metaDescription: attributes.description
        }
      : {}
  }, [attributes])

  const router = useRouter()

  // Check if the required data was provided
  if (!router.isFallback && !attributes) {
    return <ErrorPage statusCode={404} />
  }

  return (
    <>
      <Seo metadata={seo} />
      <JobOfferDetails jobOffer={attributes} />
    </>
  )
}

export async function getStaticPaths() {
  const pages = await (await fetch(getStrapiURL('/job-offers'))).json()
  const paths = pages.data.map(({ id }) => ({
    params: {
      id: id.toString()
    }
  }))
  return { paths, fallback: true }
}

export async function getStaticProps({ params }) {
  const jobOfferData = await getJobOfferData(params.id)

  if (!jobOfferData) {
    return { props: {} }
  }

  const {
    data: { attributes },
    meta
  } = jobOfferData

  return {
    props: { attributes, meta },
    revalidate: 360
  }
}

export default JobOfferPage
